import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import { locales } from '@/i18n-setup';
import helper, { _loadConfig } from '@/services/helper';
import Q from 'q';
import api from '@/services/api';
import VueRecaptcha from 'vue-recaptcha';

var config: {
  Types: SelectOption[]
} = _loadConfig('ticket');

@Component<HelpMixins>({
  computed: {
    ...mapState({
      Lang: 'Lang',
      ShowLanguages: 'ShowLanguages',
      CommitteeEmail: 'CommitteeEmail',
      CaptchaKey: 'CaptchaKey',
      ShowCaptcha: 'ShowCaptcha',
    }),
  },
})
export default class HelpMixins extends VueBase {
  public readonly ShowLanguages!: string;
  public readonly Lang!: string;
  public readonly CommitteeEmail!: string;
  public readonly CaptchaKey!: string;
  public readonly ShowCaptcha!: boolean;

  public help: VoterIssue = {
    PersonalNumber: '',
    Mobile: '',
    Email: '',
    FName: '',
    LName: '',
    Description: '',
    IssueType: 0,
  };
  public showMsgWrongDates: boolean = true;
  public msgWrongDates: string = '';
  private tocken: string = '';

  get emailLink() {
    return `<a href="mailto:${this.CommitteeEmail}">${this.CommitteeEmail}</a>`;
  }

  get Types() {
    return config.Types;
  }

  getRecaptcha() {
    return this.$refs.recaptcha as VueRecaptcha;
  }

  async mounted() {
    helper.swalShowLoading();
    let apiResult = await api.CheckElectionDates();
    if (apiResult.ErrorMessage) {
      helper.swalWarning({ text: apiResult.ErrorMessage });
      return;
    }
    this.showMsgWrongDates = apiResult.Response && apiResult.Response.data;
    if (this.showMsgWrongDates) {
      this.msgWrongDates = apiResult.Response!.data;
    }
    helper.close();
  }

  public onVerifyCaptcha(response: string) {
    this.tocken = response;
  }

  async onSubmitClick() {
    if (this.ShowCaptcha) {
      if (!this.tocken || this.tocken.length === 0) {
        helper.swalWarning(this.$t('vs.api.error.ConfirmCaptcha'));
        return;
      }
    }
    this.help.IssueType = Number(this.help.IssueType);

    helper.swalShowLoading();
    var resp = await (await api.SubmitIssue(this.help, this.tocken)).getData(true);

    if (this.ShowCaptcha) {
      let el = this.getRecaptcha();
      if (el) el.reset();
    }
    this.tocken = '';
    if (!resp) return;
    var openTicket = await helper.swalConfirm({
      title: 'Ticket sent',
      text: 'Open ticket traking page?',
      icon: 'success',
    });
    if (openTicket) {
      this.$router.push({ name: 'HelpStatus', params: { tocken: resp.Tocken } });
    }
  }
}
